
import * as export0 from "/opt/build/repo/packages/dsi-logo-maker/functions/canvas-fps/index.js";
import * as export1 from "/opt/build/repo/packages/dsi-logo-maker/functions/canvas-fps-custom/index.js";
import * as export2 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillAnimatedCanvas/index.js";
import * as export3 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillAnimatedSVG/index.js";
import * as export4 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillCanvas/index.js";
import * as export5 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillSVG/index.js";
import * as export6 from "/opt/build/repo/packages/dsi-logo-maker/functions/flagBuilderCanvas/index.js";
import * as export7 from "/opt/build/repo/packages/dsi-logo-maker/functions/flagBuilderSVG/index.js";
import * as export8 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoAnimatedCanvas/index.js";
import * as export9 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoAnimatedSVG/index.js";
import * as export10 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoCanvas/index.js";
import * as export11 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoSVG/index.js";
import * as export12 from "/opt/build/repo/packages/dsi-logo-maker/functions/p5-fps/index.js";
import * as export13 from "/opt/build/repo/packages/dsi-logo-maker/functions/pinSVG/index.js";
import * as export14 from "/opt/build/repo/packages/dsi-logo-maker/functions/playCanvas/index.js";
import * as export15 from "/opt/build/repo/packages/dsi-logo-maker/functions/playSVG/index.js";
import * as export16 from "/opt/build/repo/packages/dsi-logo-maker/functions/react-fps/index.js";
import * as export17 from "/opt/build/repo/packages/dsi-logo-maker/functions/react-fps-custom/index.js";
import * as export18 from "/opt/build/repo/packages/dsi-logo-maker/functions/svg-fps/index.js";
import * as export19 from "/opt/build/repo/packages/dsi-logo-maker/functions/svg-fps-custom/index.js";
import * as export20 from "/opt/build/repo/packages/dsi-logo-maker/functions/svg-static/index.js";
import * as export21 from "/opt/build/repo/packages/dsi-logo-maker/functions/textAndImageCanvas/index.js";
import * as export22 from "/opt/build/repo/packages/dsi-logo-maker/functions/textAndImageSVG/index.js";
import * as export23 from "/opt/build/repo/packages/dsi-logo-maker/functions/textAnimatedCanvas/index.js";
import * as export24 from "/opt/build/repo/packages/dsi-logo-maker/functions/textCanvas/index.js";

export default {
  "canvas-fps": export0,
"canvas-fps-custom": export1,
"fillAnimatedCanvas": export2,
"fillAnimatedSVG": export3,
"fillCanvas": export4,
"fillSVG": export5,
"flagBuilderCanvas": export6,
"flagBuilderSVG": export7,
"logoAnimatedCanvas": export8,
"logoAnimatedSVG": export9,
"logoCanvas": export10,
"logoSVG": export11,
"p5-fps": export12,
"pinSVG": export13,
"playCanvas": export14,
"playSVG": export15,
"react-fps": export16,
"react-fps-custom": export17,
"svg-fps": export18,
"svg-fps-custom": export19,
"svg-static": export20,
"textAndImageCanvas": export21,
"textAndImageSVG": export22,
"textAnimatedCanvas": export23,
"textCanvas": export24
};
